import { c as _c } from "react/compiler-runtime";
import Section from "@components/Section";
import ButtonBlock from "@components/blocks/Button";
import { LinkOne } from "@icon-park/svg";
import { Button, Icon, Tabs, TabsContent, TabsList, TabsTrigger } from "@justhome/react-ui";
import { ComponentSectionsRepaymentCalculator } from "@lib/generated/graphql";
import useShare from "@lib/hooks/useShare";
import { isClient } from "@lib/settings";
import RepaymentCalculatorDetails from "@modules/homepage/sections/RepaymentCalculator/RepaymentCalculatorDetails";
import { FC, useCallback, useEffect, useState } from "react";
import RepaymentCalculatorForm from "./RepaymentCalculatorForm";
import RepaymentChart from "./RepaymentChart";
import { calculateRepayment, CompleteRepaymentPlan, getRepaymentRate } from "./calculateRepayment";
import { RepaymentCalculatorFormValue } from "./types";
import useRepaymentCalculatorParams from "./useRepaymentCalculatorParams";
export interface RepaymentCalculatorProps {
  data: ComponentSectionsRepaymentCalculator;
}
const now = new Date();
const RepaymentCalculator: FC<RepaymentCalculatorProps> = t0 => {
  const $ = _c(59);
  const {
    data
  } = t0;
  const [repaymentPlan, setRepaymentPlan] = useState();
  const [repaymentPlanSecondVariant, setRepaymentPlanSecondVariant] = useState();
  const [suggestedSecondaryRepaymentRate, setSuggestedSecondaryRepaymentRate] = useState();
  const [suggestedSecondaryRepaymentRateSecondVariant, setSuggestedSecondaryRepaymentRateSecondVariant] = useState();
  const {
    storeValuesToUrl,
    urlValue,
    urlValueSecondVariant,
    isNotDefault
  } = useRepaymentCalculatorParams(data.defaultValues, data.defaultValuesSecondVariant);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = isClient ? window.location.toString() : "";
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    handleShare,
    isCopySuccess
  } = useShare(t1);
  let t2;
  let t3;
  if ($[1] !== urlValueSecondVariant) {
    t2 = () => {
      if (!urlValueSecondVariant) {
        return;
      }
      const startDate = new Date();
      startDate.setMonth(startDate.getMonth() + 1);
      const repaymentPlan_0 = calculateRepayment(urlValueSecondVariant as RepaymentCalculatorFormValue, startDate);
      setRepaymentPlanSecondVariant(repaymentPlan_0);
      const secondaryRepaymentRate = getRepaymentRate(repaymentPlan_0.repayment.residualDept, urlValueSecondVariant.interestRate, repaymentPlan_0.repayment.monthlyRepayment);
      setSuggestedSecondaryRepaymentRateSecondVariant(secondaryRepaymentRate);
    };
    t3 = [urlValueSecondVariant];
    $[1] = urlValueSecondVariant;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  let t4;
  if ($[4] !== storeValuesToUrl || $[5] !== urlValue || $[6] !== urlValueSecondVariant) {
    t4 = secondVariant => values => {
      const startDate_0 = new Date(now);
      startDate_0.setMonth(startDate_0.getMonth() + 1);
      const repaymentPlan_1 = calculateRepayment(values, startDate_0);
      secondVariant ? setRepaymentPlanSecondVariant(repaymentPlan_1) : setRepaymentPlan(repaymentPlan_1);
      const secondaryRepaymentRate_0 = getRepaymentRate(repaymentPlan_1.repayment.residualDept, values.interestRate, repaymentPlan_1.repayment.monthlyRepayment);
      secondVariant ? setSuggestedSecondaryRepaymentRateSecondVariant(secondaryRepaymentRate_0) : setSuggestedSecondaryRepaymentRate(secondaryRepaymentRate_0);
      secondVariant ? storeValuesToUrl(urlValue as RepaymentCalculatorFormValue, {
        ...values,
        secondaryRepaymentRate: secondaryRepaymentRate_0
      }) : storeValuesToUrl({
        ...values,
        secondaryRepaymentRate: secondaryRepaymentRate_0
      }, urlValueSecondVariant as RepaymentCalculatorFormValue);
    };
    $[4] = storeValuesToUrl;
    $[5] = urlValue;
    $[6] = urlValueSecondVariant;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const handleFormChange = t4;
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <TabsList className="w-full"><TabsTrigger className="grow" value="variant1">Variante 1</TabsTrigger><TabsTrigger className="grow" value="variant2">Variante 2</TabsTrigger></TabsList>;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== handleFormChange || $[10] !== suggestedSecondaryRepaymentRate || $[11] !== urlValue) {
    t6 = urlValue && <RepaymentCalculatorForm secondaryRepaymentRate={suggestedSecondaryRepaymentRate} onChange={handleFormChange(false)} defaultValues={urlValue} />;
    $[9] = handleFormChange;
    $[10] = suggestedSecondaryRepaymentRate;
    $[11] = urlValue;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t6) {
    t7 = <TabsContent value="variant1" className="pt-m">{t6}</TabsContent>;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== handleFormChange || $[16] !== suggestedSecondaryRepaymentRateSecondVariant || $[17] !== urlValueSecondVariant) {
    t8 = urlValueSecondVariant && <RepaymentCalculatorForm secondaryRepaymentRate={suggestedSecondaryRepaymentRateSecondVariant} onChange={handleFormChange(true)} defaultValues={urlValueSecondVariant} />;
    $[15] = handleFormChange;
    $[16] = suggestedSecondaryRepaymentRateSecondVariant;
    $[17] = urlValueSecondVariant;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t8) {
    t9 = <TabsContent value="variant2" className="pt-m">{t8}</TabsContent>;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t7 || $[22] !== t9) {
    t10 = <div className="m:max-w-[340px] w-full flex-none relative"><Tabs className="min-h-[805px] m:min-h-none" defaultValue="variant1">{t5}{t7}{t9}</Tabs></div>;
    $[21] = t7;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== isNotDefault || $[25] !== repaymentPlan || $[26] !== repaymentPlanSecondVariant) {
    t11 = repaymentPlan && <RepaymentChart repaymentPlan={repaymentPlan} repaymentPlanSecondVariant={repaymentPlanSecondVariant} isNotDefault={isNotDefault} />;
    $[24] = isNotDefault;
    $[25] = repaymentPlan;
    $[26] = repaymentPlanSecondVariant;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== t11) {
    t12 = <div className="pt-s m:pt-2m px-s m:px-2m relative h-[280px] m:h-[360px] w-full">{t11}</div>;
    $[28] = t11;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== repaymentPlan) {
    t13 = <RepaymentCalculatorDetails title="Variante 1" repaymentPlan={repaymentPlan} />;
    $[30] = repaymentPlan;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  let t14;
  if ($[32] !== repaymentPlanSecondVariant) {
    t14 = <RepaymentCalculatorDetails title="Variante 2" repaymentPlan={repaymentPlanSecondVariant} />;
    $[32] = repaymentPlanSecondVariant;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  let t15;
  if ($[34] !== t13 || $[35] !== t14) {
    t15 = <div className="mt-l m:mt-xl p-s m:px-3m m:py-m s:grid s:grid-cols-2 border-t border-neutral-50 flex-1">{t13}{t14}</div>;
    $[34] = t13;
    $[35] = t14;
    $[36] = t15;
  } else {
    t15 = $[36];
  }
  let t16;
  if ($[37] !== isCopySuccess) {
    t16 = isCopySuccess ? <Icon type="Check" /> : <Icon icon={LinkOne} />;
    $[37] = isCopySuccess;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  const t17 = isCopySuccess ? "In Zwischenablage kopiert!" : "Link kopieren";
  let t18;
  if ($[39] !== handleShare || $[40] !== t16 || $[41] !== t17) {
    t18 = <Button variant="ghost" iconStart={t16} size="md" onClick={handleShare}>{t17}</Button>;
    $[39] = handleShare;
    $[40] = t16;
    $[41] = t17;
    $[42] = t18;
  } else {
    t18 = $[42];
  }
  let t19;
  if ($[43] !== data.button) {
    t19 = data.button && <ButtonBlock {...data.button} iconEnd="ArrowRight" size="md" />;
    $[43] = data.button;
    $[44] = t19;
  } else {
    t19 = $[44];
  }
  let t20;
  if ($[45] !== t18 || $[46] !== t19) {
    t20 = <div className="flex flex-col-reverse m:flex-row items-center justify-end gap-2xs border-t border-neutral-50 p-s m:px-3m m:py-m mt-auto">{t18}{t19}</div>;
    $[45] = t18;
    $[46] = t19;
    $[47] = t20;
  } else {
    t20 = $[47];
  }
  let t21;
  if ($[48] !== t12 || $[49] !== t15 || $[50] !== t20) {
    t21 = <div className="overflow-hidden bg-neutral-12 rounded-m border border-neutral-50 flex-1 drop-shadow-sm flex flex-col mb-s">{t12}{t15}{t20}</div>;
    $[48] = t12;
    $[49] = t15;
    $[50] = t20;
    $[51] = t21;
  } else {
    t21 = $[51];
  }
  let t22;
  if ($[52] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <p className="text-body-2 text-neutral-675 text-opacity-60">Die hier gezeigten Berechnungen stellen eine Musterberechnung auf Basis der Angaben dar. Es ist kein Finanzierungsvorschlag und keine Aussage oder Prognose zu zukünftigen Zinsentwicklungen.</p>;
    $[52] = t22;
  } else {
    t22 = $[52];
  }
  let t23;
  if ($[53] !== t21) {
    t23 = <div className="flex flex-col overflow-hidden">{t21}{t22}</div>;
    $[53] = t21;
    $[54] = t23;
  } else {
    t23 = $[54];
  }
  let t24;
  if ($[55] !== data || $[56] !== t10 || $[57] !== t23) {
    t24 = <Section className="flex flex-col m:flex-row gap-3m my-3m m:my-xl" section={data}>{t10}{t23}</Section>;
    $[55] = data;
    $[56] = t10;
    $[57] = t23;
    $[58] = t24;
  } else {
    t24 = $[58];
  }
  return t24;
};
export default RepaymentCalculator;